import { jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { SurveyCarousel } from "../SurveyCarousel.js";
function SurveysPart({ part, allParts }) {
  var _a;
  if (isCallState(part.state)) return null;
  const output = part.output;
  if (isOutputState(part.state) && ((_a = output == null ? void 0 : output.surveys) == null ? void 0 : _a.length) && output.surveys.length > 0) {
    return /* @__PURE__ */ jsx(SurveyCarousel, { surveys: output.surveys });
  }
  return null;
}
export {
  SurveysPart
};
//# sourceMappingURL=SurveysPart.js.map
